import { Box, TextField, Typography, useMediaQuery, useTheme } from "@mui/material";

// Helper-Komponente für die Anzeige von Seitenkontingenten
export const PageQuotaEditable = ({
    leftValue,
    rightValue,
    leftLabel = "Übrig",
    rightLabel = "Gesamt",
    onRightChange,
    disabled = false,
    isInvalid = false,
}: {
    leftValue: number;
    rightValue: number;
    leftLabel?: string;
    rightLabel?: string;
    onRightChange?: (value: number) => void;
    disabled?: boolean;
    isInvalid?: boolean;
}) => {
    const theme = useTheme();
    const isXsScreen = useMediaQuery(theme.breakpoints.down('sm'));
    
    const textFieldWidth = isXsScreen ? 70 : 100;
    
    return (
        <Box sx={{ 
            display: "flex", 
            alignItems: "center", 
            flexWrap: isXsScreen ? "wrap" : "nowrap",
            justifyContent: "flex-end",
            width: "100%"
        }}>
            <TextField
                size="small"
                label={leftLabel}
                type="number"
                value={leftValue}
                disabled={true}
                sx={{
                    width: textFieldWidth,
                    "& .MuiInputBase-input": {
                        textAlign: "right",
                    },
                }}
            />

            <Typography sx={{ mx: 1 }}>/</Typography>

            <TextField
                size="small"
                label={rightLabel}
                type="number"
                value={rightValue}
                disabled={true}
                sx={{
                    width: textFieldWidth,
                }}
                InputProps={{
                    sx: {
                        bgcolor: isInvalid ? "rgba(255, 0, 0, 0.05)" : "inherit",
                    },
                }}
            />
        </Box>
    );
};
